import { tl } from '../utils/helpers';

function Block({ title, children }) {
  return (
    <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 20, padding: '1.3rem' }}>
      <div style={{ fontFamily: 'var(--font-mono)', fontSize: '0.6rem', letterSpacing: '0.18em', textTransform: 'uppercase', color: 'var(--muted)', marginBottom: '1.1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <span style={{ width: 14, height: 2, background: 'linear-gradient(90deg,var(--teal),var(--violet))', borderRadius: 2, flexShrink: 0, display: 'inline-block' }} />
        {title}
      </div>
      {children}
    </div>
  );
}

export default function Sidebar({ user, items, watchlist, onRemove }) {
  const genres = user.genres.map((g, i) => ({ g, p: [90, 72, 54][i] }));
  const avg = items.length ? Math.round(items.reduce((a, b) => a + b.score, 0) / items.length) : 0;

  const breakdown = [
    { l: 'Collaborative Filter', p: 78, grad: 'linear-gradient(90deg,var(--teal),var(--sky))'    },
    { l: 'Content-Based',        p: 85, grad: 'linear-gradient(90deg,var(--violet),var(--rose2))' },
    { l: 'Recency Boost',        p: 62, grad: 'linear-gradient(90deg,var(--gold),var(--amber))'   },
    { l: 'Social Signals',       p: 70, grad: 'linear-gradient(90deg,var(--green),var(--teal))'   },
  ];

  return (
    <div style={{ position: 'sticky', top: 82, display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>

      {/* Stats */}
      <Block title="Profile Stats">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
          {[{ n: user.watched, l: 'Watched' }, { n: user.read, l: 'Read' }, { n: items.length, l: 'Recs' }, { n: `${avg}%`, l: 'Avg Match' }].map(({ n, l }) => (
            <div key={l} style={{ background: 'var(--surface2)', border: '1px solid var(--border)', borderRadius: 12, padding: '0.9rem', textAlign: 'center' }}>
              <span style={{ fontFamily: 'var(--font-display)', fontSize: '1.7rem', fontWeight: 700, color: 'var(--gold)', display: 'block', lineHeight: 1 }}>{n}</span>
              <div style={{ fontFamily: 'var(--font-mono)', fontSize: '0.58rem', color: 'var(--muted)', marginTop: '0.3rem', letterSpacing: '0.08em', textTransform: 'uppercase' }}>{l}</div>
            </div>
          ))}
        </div>
      </Block>

      {/* Genre Affinity */}
      <Block title="Genre Affinity">
        {genres.map(({ g, p }) => (
          <div key={g} style={{ marginBottom: '0.85rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.78rem', marginBottom: '0.35rem' }}>
              <span>{g}</span>
              <span style={{ fontFamily: 'var(--font-mono)', fontSize: '0.68rem', color: 'var(--muted)' }}>{p}%</span>
            </div>
            <div style={{ height: 5, background: 'var(--border)', borderRadius: 3, overflow: 'hidden' }}>
              <div style={{ height: '100%', width: `${p}%`, background: 'linear-gradient(90deg,var(--teal),var(--violet))', borderRadius: 3, transition: 'width 1.2s cubic-bezier(.4,0,.2,1)' }} />
            </div>
          </div>
        ))}
      </Block>

      {/* AI Breakdown */}
      <Block title="AI Score Breakdown">
        {breakdown.map(b => (
          <div key={b.l} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.65rem' }}>
            <div style={{ fontSize: '0.74rem', color: 'var(--text2)', width: 108, flexShrink: 0 }}>{b.l}</div>
            <div style={{ flex: 1, height: 4, background: 'var(--border)', borderRadius: 2, overflow: 'hidden' }}>
              <div style={{ height: '100%', width: `${b.p}%`, background: b.grad, borderRadius: 2, transition: 'width 1s ease' }} />
            </div>
            <div style={{ fontFamily: 'var(--font-mono)', fontSize: '0.64rem', color: 'var(--muted)', width: 32, textAlign: 'right', flexShrink: 0 }}>{b.p}%</div>
          </div>
        ))}
      </Block>

      {/* Watchlist */}
      <Block title={`Watchlist (${watchlist.length})`}>
        {watchlist.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '1.5rem 0', fontFamily: 'var(--font-mono)', fontSize: '0.7rem', color: 'var(--muted)' }}>
            Nothing saved yet.<br />Tap + on any card.
          </div>
        ) : (
          watchlist.map(it => (
            <div key={it.id} style={{ display: 'flex', gap: '0.7rem', alignItems: 'center', padding: '0.62rem 0', borderBottom: '1px solid var(--border)' }}>
              <img src={it.img} alt={it.title} style={{ width: 44, height: 44, borderRadius: 8, objectFit: 'cover', flexShrink: 0 }} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '0.82rem', fontWeight: 700, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{it.title}</div>
                <div style={{ fontFamily: 'var(--font-mono)', fontSize: '0.59rem', color: 'var(--muted)', marginTop: 2 }}>{tl(it.type)} · {it.score}% match</div>
              </div>
              <button onClick={() => onRemove(it.id)} style={{ background: 'transparent', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: '0.85rem', padding: '0.2rem', flexShrink: 0, transition: 'color 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.color = 'var(--rose)'}
                onMouseLeave={e => e.currentTarget.style.color = 'var(--muted)'}
              >✕</button>
            </div>
          ))
        )}
      </Block>
    </div>
  );
}
